// Salient "nectar toggles" -> native <details> accordions.
// Migrated WP pages (trade, timber-types, kit pages) carry toggle markup that needs Salient JS
// we don't load; without it the panels render as flat always-open text. This converts each
// .toggle into a <details class="sw-toggle"> styled by the existing .page-content details CSS.
// Loaded conditionally by blocks/page-content.liquid when the body contains 'class="toggle'.
// WP default state: closed (Salient data-starting="default"); a .toggle.default.open would open.
(function () {
  function convert() {
    document.querySelectorAll('.page-content .toggles .toggle').forEach(function (t) {
      if (t.dataset.swConverted) return;
      var titleLink = t.querySelector('.toggle-title a, h3 a');
      var title = titleLink ? titleLink.textContent.trim() : (t.querySelector('h3') || {}).textContent;
      if (!title) return;
      var body = t.querySelector('.inner-toggle-wrap');
      if (!body) return;
      var details = document.createElement('details');
      details.className = 'sw-toggle';
      if (t.classList.contains('open')) details.open = true;
      var summary = document.createElement('summary');
      summary.textContent = title.trim();
      details.appendChild(summary);
      var content = document.createElement('div');
      content.className = 'sw-toggle__body';
      while (body.firstChild) content.appendChild(body.firstChild);
      details.appendChild(content);
      t.dataset.swConverted = '1';
      t.replaceWith(details);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', convert);
  else convert();
})();
